import React, { useState, useEffect, ChangeEvent } from 'react';
import './TextBoxList.scss';

interface TextBoxListProps {
  name: string;
  placeholder: string;
  addInputBtnText: string;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  onChange: (value: string[]) => void;
}

export const TextBoxList = ({
  name,
  placeholder,
  onChange,
  onBlur,
  addInputBtnText,
}: TextBoxListProps) => {
  const [inputs, setInputs] = useState<string[]>(['']);

  const removeInput = (index: number) => {
    const newInputs = [...inputs];
    newInputs.splice(index, 1);
    setInputs(newInputs);
  };

  const addInput = () => {
    setInputs([...inputs, '']);
  };

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { value } = e.target;
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);
  };

  useEffect(() => {
    onChange(inputs);
  }, [inputs]);

  return (
    <>
      {inputs.map((value, index) => (
        <div key={index} style={{ display: 'flex' }}>
          <input
            type='text'
            className='c-common-input c-form-serial-input-val'
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              onChangeInput(e, index);
            }}
            onBlur={onBlur}
          />
          {index !== 0 && (
            <span style={{ margin: '10px', flexBasis: '2%' }}>
              <i
                className='icon-cancel-circle'
                onClick={() => {
                  removeInput(index);
                }}
              />
            </span>
          )}
        </div>
      ))}

      {addInputBtnText && (
        <span className='c-contact-us-field-label c-contact-link-btn-label' onClick={addInput}>
          + {addInputBtnText}
        </span>
      )}
    </>
  );
};
